import firebase from "../../Firebase";
import { getAuthUser } from "../../lib/effectiveAuthUser";

/** Create a guest only when Firebase is signed out, never during admin bootstrap. */
export async function authenticateCommenter() {
  const currentUser = getAuthUser();
  if (currentUser) return currentUser;

  const auth = firebase.auth();
  if (auth.currentUser) {
    // A synthetic credential may exist before its effective customer has been
    // validated. Replacing it with an anonymous login would discard the session.
    throw new Error("Your session is still loading. Please try commenting again.");
  }
  const { user } = await auth.signInAnonymously();
  return user;
}
